import React from 'react';
import './Layout.css';

interface SidebarProps {
    isOpen: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen }) => {
    return (
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <nav style={{ padding: '1rem' }}>
                <h2>Menü</h2>
                <ul>
                    <li>Dashboard</li>
                    <li>Profil</li>
                    <li>Einstellungen</li>
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;